import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { columnDefs } from './_utils/defination-config.jsx';
import {
  downloadAlmaxData,
  getAllabcatReport,
  sendEmail,
} from '../../../services/apiService';
import { toast } from 'react-toastify';
import RejectFormModal from './component/RejectFormModal';
import LoadingCircleIcon from '../../../icons/LoadingCircle.jsx';
import useUrlFilters from '../../../extras/useUrlFilters';

const pageSize = 10;
const COURSE_OPTIONS = [
  { value: '', label: 'All Courses' },
  { value: 'data-science', label: 'Data Science' },
  { value: 'web3', label: 'Web Development' },
];
const TIME_OPTIONS = [
  { value: 'last1hours', label: 'Last 1 Hour' },
  { value: 'last4hours', label: 'Last 4 Hours' },
  { value: 'last8hours', label: 'Last 8 Hours' },
  { value: 'last24hours', label: 'Last 24 Hours' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7days', label: 'Last 7 Days' },
  { value: 'last45days', label: 'Last 45 Days' },
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'allTime', label: 'All Time' },
];

function getTimeRangePayload(dateRange) {
  const now = new Date();
  let start = null;
  let end = null;
  switch (dateRange) {
    case 'last1hours':
      end = new Date();
      start = new Date(end.getTime() - 1 * 60 * 60 * 1000);
      break;
    case 'last4hours':
      end = new Date();
      start = new Date(end.getTime() - 4 * 60 * 60 * 1000);
      break;
    case 'last8hours':
      end = new Date();
      start = new Date(end.getTime() - 8 * 60 * 60 * 1000);
      break;
    case 'last24hours':
      end = new Date();
      start = new Date(end.getTime() - 24 * 60 * 60 * 1000);
      break;
    case 'yesterday':
      start = new Date();
      start.setDate(now.getDate() - 1);
      start.setHours(0, 0, 0, 0);
      end = new Date(start);
      end.setHours(23, 59, 59, 999);
      break;
    case 'last7days':
      start = new Date();
      start.setDate(now.getDate() - 6);
      start.setHours(0, 0, 0, 0);
      end = new Date();
      end.setHours(23, 59, 59, 999);
      break;
    case 'last45days':
      start = new Date();
      start.setDate(now.getDate() - 44);
      start.setHours(0, 0, 0, 0);
      end = new Date();
      end.setHours(23, 59, 59, 999);
      break;
    case 'thisMonth':
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      end = new Date();
      end.setHours(23, 59, 59, 999);
      break;
    case 'lastMonth':
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      start.setHours(0, 0, 0, 0);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
      end.setHours(23, 59, 59, 999);
      break;
    default:
      start = null;
      end = null;
  }
  return {
    start: start ? start.toISOString() : null,
    end: end ? end.toISOString() : null,
  };
}

function mapAbCatEvaluationToForm(abCatEvaluation) {
  // Map decision from status
  let decision = '';
  if (abCatEvaluation.status === 'approved') decision = 'approve';
  else if (abCatEvaluation.status === 'rejected') decision = 'reject';
  // Map internalRemarks from interviewNotes
  let internalRemarks = [];
  if (Array.isArray(abCatEvaluation.data?.interviewNotes)) {
    internalRemarks = abCatEvaluation.data.interviewNotes;
  } else if (abCatEvaluation.data?.interviewNotes) {
    internalRemarks = [{ id: 1, remark: abCatEvaluation.data.interviewNotes }];
  }
  // Fix mapping for shortlisted
  let shortlisted = '';
  if (abCatEvaluation.shortList === true) shortlisted = 'yes';
  else if (abCatEvaluation.shortList === false) shortlisted = 'no';
  return {
    languageProficiency: abCatEvaluation.languageProficiency || '',
    technicalFluencyAudited: abCatEvaluation.technicalFluencyAudited === 'Yes',
    commFluencyAudited: abCatEvaluation.commFluencyAudited === 'Yes',
    foundCopying: abCatEvaluation.foundCopying === 'Yes',
    shortlisted,
    almaXCohort: abCatEvaluation.data?.almaXCohort || '',
    internalRemarks,
    rejectionReasons: abCatEvaluation.rejectReason || '',
    decision,
    // Add other fields as needed
  };
}

const ABCATReport = () => {
  const [gridApi, setGridApi] = useState(null);
  console.log(gridApi, 'gridApi');

  const DEFAULT_FILTERS = {
    timeRange: 'last24hours',
    email: '',
    course: '',
    shortlisted: '',
    decision: '',
    almaXCohort: '',
  };

  const {
    filters: filterInputs,
    setFilters: setFilterInputs,
    clearFilters: clearUrlFilters,
  } = useUrlFilters({ defaultFilters: DEFAULT_FILTERS });
  const [refresh, setRefresh] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectForm, setRejectForm] = useState({
    decision: '',
    technicalFluencyAudited: false,
    commFluencyAudited: false,
    foundCopying: false,
    shortlisted: '',
    almaXCohort: '',
    internalRemarks: '',
    rejectionReasons: '',
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  console.log(selectedRow, refresh, 'timeRange');

  const getServerSideDatasource = () => {
    setFilterLoading(true);
    return {
      getRows: async (params) => {
        const { startRow } = params.request;
        const currentPage = Math.floor(startRow / pageSize) + 1;
        try {
          const timePayload = getTimeRangePayload(filterInputs.timeRange);
          let decision = '';
          if (filterInputs.decision === 'approve') decision = 'approved';
          else if (filterInputs.decision === 'reject') decision = 'rejected';
          else if (filterInputs.decision === 'pending') decision = 'pending';
          const response = await getAllabcatReport(
            currentPage,
            filterInputs.email,
            filterInputs.course,
            filterInputs.shortlisted,
            decision,
            filterInputs.almaXCohort,
            // timePayload.start,
            // timePayload.end
            ...(timePayload.start && timePayload.end
              ? [timePayload.start, timePayload.end]
              : [])
          );
          const allData = response?.data || [];
          getRowStyle(allData);
          const totalCount = response?.totalRecords;
          params.successCallback(allData, totalCount);
        } catch (err) {
          toast.error('Failed to fetch data');
          params.failCallback();
        } finally {
          setFilterLoading(false);
        }
      },
    };
  };

  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api);
      const datasource = getServerSideDatasource();
      params.api.setServerSideDatasource(datasource);
    },
    [filterInputs]
  );

  const handleApprove = (row) => {
    toast.success('Approved! (Demo)');
  };
  const handleReject = (row) => {
    setSelectedRow(row);
    if (row.abCatEvaluation) {
      setRejectForm(mapAbCatEvaluationToForm(row.abCatEvaluation));
    } else {
      setRejectForm({
        technicalFluencyAudited: false,
        commFluencyAudited: false,
        foundCopying: false,
        shortlisted: '',
        almaXCohort: '',
        internalRemarks: [],
        rejectionReasons: '',
        decision: '',
      });
    }
    console.log(rejectForm, 'rejectForm');
    setShowRejectModal(true);
  };
  const handleSendEmail = async (row) => {
    console.log(row, 'row');
    try {
      const id = row?.id;
      const response = await sendEmail({ id });
      console.log(response, 'response');

      if (response?.success) {
        toast.success('Email sent successfully!');
      } else if (response?.message) {
        toast.error(response.message);
      } else {
        toast.error('Failed to send email');
      }
    } catch (err) {
      console.error('Email error:', err);

      let errorMessage = 'Failed to send email';

      if (err?.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err?.response?.message) {
        errorMessage = err.response.message;
      } else if (err?.message && !err.message.includes('500')) {
        errorMessage = err.message;
      } else if (err?.data?.message) {
        errorMessage = err.data.message;
      }

      toast.error(errorMessage);
    }
  };

  const refreshGrid = () => {
    if (gridApi) {
      const newDatasource = getServerSideDatasource(); // uses current filterInputs
      gridApi.setServerSideDatasource(newDatasource);
    }
  };

  const agGridColumnDefs = useMemo(() => {
    return columnDefs({
      onApprove: handleApprove,
      onReject: handleReject,
      onSendEmail: handleSendEmail,
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterInputs((prev) => ({ ...prev, [name]: value }));
    console.log(filterInputs, 'filterinput');
  };
  const handleApplyFilter = async () => {
    setFilterLoading(true);
    try {
      if (gridApi) {
        const newDatasource = getServerSideDatasource();
        await gridApi.setServerSideDatasource(newDatasource);
      }
    } finally {
      setFilterLoading(false);
    }
  };

  const handleClearFilter = () => {
    console.log('clearfilters');
    clearUrlFilters();
    setRefresh(!refresh);
  };

  const handleDownload = async () => {
    const timePayload = getTimeRangePayload(filterInputs.timeRange);
    let decision = '';
    if (filterInputs.decision === 'approve') decision = 'approved';
    else if (filterInputs.decision === 'reject') decision = 'rejected';
    else if (filterInputs.decision === 'pending') decision = 'pending';
    const rawParams = {
      email: filterInputs.email,
      course: filterInputs.course,
      shortlisted: filterInputs.shortlisted,
      decision,
      almaXCohort: filterInputs.almaXCohort,
      ...(timePayload.start && timePayload.end
        ? { start: timePayload.start, end: timePayload.end }
        : {}),
    };

    try {
      const response = await downloadAlmaxData(
        ...Object.values(rawParams).map((val) => val || '') // Ensure empty string for undefined
      );

      // Use correct blob type
      const date = new Date().toISOString();

      console.log(response?.data, 'response');
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `AB-CAT_Report_${date}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  const handleRejectFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log(name, value, type, checked, 'aksjdfb');
    setRejectForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
  const handleRejectSubmit = (e) => {
    // e.preventDefault();
    console.log(rejectForm, 'form');
    toast.error('Rejected! (Demo)');
    setShowRejectModal(false);
    setRejectForm({
      technicalFluencyAudited: false,
      commFluencyAudited: false,
      foundCopying: false,
      shortlisted: false,
      almaXCohort: '',
      internalRemarks: '',
      rejectionReasons: '',
    });
  };
  const handleRejectModalClose = () => {
    setRejectForm({
      technicalFluencyAudited: false,
      commFluencyAudited: false,
      foundCopying: false,
      shortlisted: '',
      almaXCohort: '',
      internalRemarks: '',
      rejectionReasons: '',
    });
    setShowRejectModal(false);
  };

  const shouldHighlightRow = (rowData) => {
    console.log(rowData, 'rowData in highlight');
    if (!rowData?.updatedAt || !rowData?.abCatEvaluation?.updatedAt) {
      return false;
    }

    const reportUpdatedAt = new Date(rowData?.updatedAt);
    const evaluationUpdatedAt = new Date(rowData?.abCatEvaluation?.updatedAt);

    return reportUpdatedAt > evaluationUpdatedAt;
  };

  const getRowStyle = (params) => {
    console.log(params, 'askdjf');
    if (shouldHighlightRow(params?.data)) {
      return {
        backgroundColor: '#fff3cd', // Light yellow background
        border: '1px solid #f0ad4e', // Orange border
        // backgroundColor: '#d1ecf1', // Light blue
        // backgroundColor: '#f8d7da', // Light red
        // backgroundColor: '#d4edda', // Light green
      };
    }
    return null;
  };
  useEffect(() => {
    if (gridApi) {
      const newDatasource = getServerSideDatasource();
      gridApi.setServerSideDatasource(newDatasource);
    }
  }, [refresh]);

  return (
    <div className='flex flex-col h-screen' style={{ backgroundColor: 'var(--page-background)', color: 'var(--text-primary)' }}>
      <div className='px-8 pt-8'>
        <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text-primary, #111827)', marginBottom: 16 }}>AB-CAT Report</h1>
        <div style={{ backgroundColor: 'var(--card-background, #fff)', borderRadius: 8, boxShadow: 'var(--shadow-sm, 0 1px 6px rgba(0,0,0,0.05))', padding: 16, display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'flex-end', marginBottom: 24, border: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}>
          <div className='flex-1 flex flex-wrap gap-6 items-end'>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                Time
              </label>
              <select
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 160, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                name='timeRange'
                value={filterInputs.timeRange}
                onChange={handleInputChange}
              >
                {TIME_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                Email
              </label>
              <input
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 220, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                type='text'
                name='email'
                placeholder='Search by email'
                value={filterInputs.email}
                onChange={handleInputChange}
              />
            </div>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                Course
              </label>
              <select
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 180, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                name='course'
                value={filterInputs.course}
                onChange={handleInputChange}
              >
                {COURSE_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                Shortlisted
              </label>
              <select
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 120, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                name='shortlisted'
                value={filterInputs.shortlisted}
                onChange={handleInputChange}
              >
                <option value=''>All</option>
                <option value='yes'>Yes</option>
                <option value='no'>No</option>
                <option value='null'>Empty</option>
              </select>
            </div>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                Decision
              </label>
              <select
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 120, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                name='decision'
                value={filterInputs.decision}
                onChange={handleInputChange}
              >
                <option value=''>All</option>
                <option value='approve'>Approve</option>
                <option value='reject'>Reject</option>
                <option value='pending'>Pending</option>
              </select>
            </div>
            <div className='flex flex-col'>
              <label style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-secondary, #6B7280)', marginBottom: 4 }}>
                AlmaX Cohort Name
              </label>
              <input
                style={{ border: '1px solid var(--border-main, #D1D5DB)', borderRadius: 4, padding: '8px 12px', minWidth: 180, backgroundColor: 'var(--input-background, #fff)', color: 'var(--text-primary, #111827)', fontSize: 14 }}
                type='text'
                name='almaXCohort'
                placeholder='Search by cohort name'
                value={filterInputs.almaXCohort}
                onChange={handleInputChange}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <div className='flex flex-row gap-3 mt-auto'>
                <button
                  style={{ backgroundColor: 'var(--primary-main, #4F46E5)', color: '#fff', fontWeight: 600, padding: '8px 24px', borderRadius: 4, border: 'none', cursor: filterLoading ? 'not-allowed' : 'pointer', opacity: filterLoading ? 0.6 : 1 }}
                  onClick={handleApplyFilter}
                  type='button'
                  disabled={filterLoading}
                >
                  {filterLoading ? (
                    <span className='flex items-center'>
                      <LoadingCircleIcon iconStyle='w-5 mr-2 animate-spin' />
                      Loading...
                    </span>
                  ) : (
                    'Apply Filter'
                  )}
                </button>
                <button
                  style={{ backgroundColor: 'var(--border-light, #D1D5DB)', color: 'var(--text-primary, #111827)', fontWeight: 600, padding: '8px 24px', borderRadius: 4, border: 'none', cursor: 'pointer' }}
                  onClick={handleClearFilter}
                  type='button'
                >
                  Clear Filter
                </button>
              </div>
            </div>
          </div>
          <div className='flex flex-col justify-end mb-1 ml-auto'>
            <button
              style={{ backgroundColor: 'var(--success-main, #16A34A)', color: '#fff', fontWeight: 600, padding: '8px 24px', borderRadius: 4, border: 'none', cursor: 'pointer' }}
              onClick={handleDownload}
              type='button'
            >
              Download File
            </button>
          </div>
        </div>
      </div>
      <div className='flex-1 overflow-hidden px-8 pb-8'>
        <div
          className='ag-theme-alpine h-full w-full rounded-lg shadow'
          style={{ height: '100%', backgroundColor: 'var(--card-background, #fff)', border: '1px solid var(--border-light, rgba(0,0,0,0.07))' }}
        >
          <AgGridReact
            columnDefs={agGridColumnDefs}
            onGridReady={onGridReady}
            tooltipShowDelay={500}
            tooltipHideDelay={2000}
            enableBrowserTooltips={true}
            rowHeight={52}
            rowModelType='serverSide'
            serverSideStoreType='partial'
            animateRows={true}
            serverSideInfiniteScroll={true}
            pagination={true}
            paginationPageSize={pageSize}
            cacheBlockSize={pageSize}
            suppressPaginationPanel={false}
            domLayout='normal'
            getRowStyle={getRowStyle} 
          />
        </div>
      </div>
      {/* Reject Modal */}

      <RejectFormModal
        open={showRejectModal}
        onClose={handleRejectModalClose}
        onSubmit={handleRejectSubmit}
        form={rejectForm}
        onChange={handleRejectFormChange}
        rowData={selectedRow}
        onAfterSubmit={refreshGrid}
      />
    </div>
  );
};

export default ABCATReport;
